import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export { calculateBorders, type GroupedItem } from './borderedGroup';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export { clsx };
